import { useRouter } from "src/helpers"; // import lodash from 'lodash';
// import deepdash from 'deepdash-es';

import { withCreateContent } from "src/modules/content/operations";
import { compose } from "src/helpers";

import CreateView from "./component";

const Create = (props) => {
    const { createContent } = props;
    const router = useRouter();

    const onFinish = async (values: any) => {
        await createContent(values);
        router.push("/collection/content");
    };

    const onFinishFailed = (errorInfo: any) => {
        console.log("Failed:", errorInfo);
    };

    return <CreateView onFinish={onFinish} onFinishFailed={onFinishFailed} />;
};

export default compose(withCreateContent)(Create);
